import styled from '@emotion/styled';

const BadgeList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.spacing[2]};
`;
export default BadgeList;
